import 'bootstrap/dist/css/bootstrap.min.css';
import { useState , useEffect} from 'react';
import playersData from '../../data/data.json';
import PlayerInfo from '../PlayerInfo/PlayerInfo';
import Selected from '../Selected/Selected';
import './Players.css';

const Player = () => {
    const [players, setPlayers] = useState([]);
  useEffect(() =>{
    setPlayers(playersData);
  },[]);
  
  const [selectedPlayer, setSelectedPlayer] = useState([]);
  const handleAddPlayer = (player) => {
        const newSelectedPlayer =[...selectedPlayer,player];
        setSelectedPlayer(newSelectedPlayer);
        document.getElementById('show').style.display = 'block'; 
  }
    return (
        <section className="playersContainer">
             <section className="w-75 player-container">
            {
                players.map(player => 
                <PlayerInfo 
                    player={player}
                    handleAddPlayer={handleAddPlayer}
                    key={player.id}>
                </PlayerInfo>)
            }
             </section>
             <section className="selected-container">
                <Selected selected={selectedPlayer}></Selected>
             </section>
        </section>
       
    );
};

export default Player;